import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateToken = gql`
  mutation createToken(
    $accountID: DokkioID!
    $email: String!
    $password: String!
  ) {
    createToken(
      accountID: $accountID
      email: $email
      password: $password
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;

export default mutationCreateToken;
